import React from 'react';
import { useFormikContext } from 'formik';
import { Simulation } from '../../types/main';

interface PointsNoteProps {
  message?: string;
}
export const PointsNote: React.FC<PointsNoteProps> = ({ message }) => {
  const { values, setFieldValue } = useFormikContext();
  const simulation = values as Simulation ;
  const { points, nbTotalPoints } = simulation;
  const handleClick = (): void => {
    // alert(message);
  }

  return (
    <div id="points_note">
      <div
        id="points"
        onClick={handleClick}
        title={message}
      >
        <div>Points</div>
        <div>{nbTotalPoints === 0 ? '-' : `${Math.round(points * 10) / 10} / ${nbTotalPoints}`}</div>
      </div>
      <div
        id="note"
        onClick={handleClick}
        title={message}
      >
        <div>Note sur 20</div>
        <div>{nbTotalPoints === 0 ? '-' : Math.round(points / nbTotalPoints * 2000) / 100}</div>
      </div>
    </div>
  );
}